// AIDEV-NOTE: BACKEND-368 — shared contract between api.meditation.hls and
// useStreamingMeditation. The bootstrap route waits ~30s for the live HLS
// session to become playable, then 503s. A slow/silent first Inngest attempt
// (retried ~45s later) used to surface as "Failed to prepare audio" while the
// generation was still on track. The route tags the 503 with this code ONLY
// when a repeat bootstrap request reuses the in-progress generation (by-type
// path, session still pending — never errored, exercise, meditationId replay,
// provider replay, or local fixture), so the client can re-request safely
// without starting a second generation.
export const MEDITATION_HLS_STILL_PREPARING_CODE =
    "MEDITATION_HLS_STILL_PREPARING";

// Delays before each automatic re-request (2 retries => 3 requests total).
// Each server request already waits up to ~30s, so the backoff stays short.
export const MEDITATION_HLS_BOOTSTRAP_RETRY_DELAYS_MS = [1_000, 2_000] as const;

export function isRetryableHlsBootstrapResponse(
    status: number,
    payload: unknown,
): boolean {
    return (
        status === 503 &&
        typeof payload === "object" &&
        payload !== null &&
        "code" in payload &&
        payload.code === MEDITATION_HLS_STILL_PREPARING_CODE
    );
}
